// Copyright (c) 2019 Celadon Development LLC, All rights reserved.
// Author Yana Sidorova <yana.sidorova@celadon.ae>
import GlobalStyles from '../../config/styles';

const styles = theme => ({
  inputContainerIndex: {
    width: 680,
    marginTop: 30,
    marginLeft: '30%',
    [theme.breakpoints.down(2000)]: {
      marginLeft: '20%',
    },
    [theme.breakpoints.down(1750)]: {
      marginLeft: '10%',
    },
    [theme.breakpoints.down(1550)]: {
      marginLeft: 100,
    },
    [theme.breakpoints.down(1310)]: {
      width: 600,
    },
    [theme.breakpoints.down(1150)]: {
      width: 550,
    },
    [theme.breakpoints.down(1000)]: {
      width: 500,
      marginLeft: '10%',
    },
    [theme.breakpoints.down(900)]: {
      width: 440,
    },
    [theme.breakpoints.down(500)]: {
      width: '93%',
      marginLeft: 10,
    },
  },
  inputContainerIndexForHome: {
    width: '100%',
  },
  inputContainer: {
    width: 530,
    display: 'flex',
    flexDirection: 'column',
    [theme.breakpoints.down(800)]: {
      width: 400,
    },
    [theme.breakpoints.down(700)]: {
      width: 350,
    },
    [theme.breakpoints.down(500)]: {
      width: '95%',
    },
  },
  btnPrimary: {
    backgroundColor: GlobalStyles.color.COLOR_SECONDARY,
    border: 'none',
    fontFamily: GlobalStyles.fonts.FONT_ANLTP_BOLD,
    color: GlobalStyles.color.COLOR_PRIMARY,
    fontSize: 20,
    padding: '0 20px',
    [theme.breakpoints.down(500)]: {
      fontSize: GlobalStyles.fonts.FONT_SIZE,
    },
  },
  inputButtonContainer: {
    margin: '5px 0 !important',
    position: 'relative',
    height: 80,
    [theme.breakpoints.down(500)]: {
      height: 50,
    },
  },
  input: {
    borderWidth: 2,
    height: 80,
    fontSize: GlobalStyles.fonts.FONT_SIZE_MAX,
    fontFamily: GlobalStyles.fonts.FONT_ANLTP_REGULAR,
    color: GlobalStyles.color.COLOR_GREY,
    paddingLeft: 80,
    paddingTop: 10,
    '&::-webkit-input-placeholder': {
      fontSize: GlobalStyles.fonts.FONT_SIZE_LARGE,
      fontFamily: GlobalStyles.fonts.FONT_ANLTP_REGULAR,
      color: '#8E8E93',
      [theme.breakpoints.down(1025)]: {
        fontSize: GlobalStyles.fonts.FONT_SIZE_TITLE,
      },
      [theme.breakpoints.down(900)]: {
        fontSize: GlobalStyles.fonts.FONT_SIZE,
        paddingTop: 0,
      },
    },
    '&::-moz-placeholder': {
      fontSize: GlobalStyles.fonts.FONT_SIZE_LARGE,
      fontFamily: GlobalStyles.fonts.FONT_ANLTP_REGULAR,
      color: '#8E8E93',
    },
    [theme.breakpoints.down(900)]: {
      paddingLeft: 60,
    },
    [theme.breakpoints.down(500)]: {
      height: 50,
      paddingLeft: 40,
      fontSize: GlobalStyles.fonts.FONT_SIZE,
    },
  },
  helper: {
    fontFamily: GlobalStyles.fonts.FONT_ANLTP_REGULAR,
    fontSize: GlobalStyles.fonts.FONT_SIZE_SMALL,
    color: GlobalStyles.color.COLOR_GREY,
  },
  inputHelper: {
    fontFamily: GlobalStyles.fonts.FONT_ANLTP_REGULAR,
    fontSize: 17,
    color: GlobalStyles.color.COLOR_GREY,
    [theme.breakpoints.down(1100)]: {
      fontSize: GlobalStyles.fonts.FONT_SIZE_SMALL,
    },
  },
  errorContainer: {
    display: 'flex',
    flexDirection: 'row',
    alignItems: 'center',
    marginTop: 10,
  },
  errorNotifyContainer: {
    display: 'flex',
    flexDirection: 'column',
    marginTop: 10,
  },
  errorText: {
    marginBottom: 10,
  },
  error: {
    color: 'red',
    fontSize: GlobalStyles.fonts.FONT_SIZE,
    fontFamily: GlobalStyles.fonts.FONT_ANLTP_BOLD,
    marginLeft: 7,
    [theme.breakpoints.down(340)]: {
      fontSize: GlobalStyles.fonts.FONT_SIZE_SMALL,
    },
  },
  failedIcon: {
    display: 'flex',
    marginLeft: 10,
    width: 30,
    height: 30,
  },
  buttonBottomHelper: {
    textDecoration: 'none',
    marginTop: 10,
    backgroundColor: GlobalStyles.color.COLOR_PRIMARY,
    textAlign: 'left',
    border: 'none',
    '&:focus': {
      outline: 'none',
    },
  },
  modalContainer: {
    display: 'flex',
    flexDirection: 'column',
    backgroundColor: GlobalStyles.color.COLOR_PRIMARY,
    width: 650,
    borderRadius: 15,
    [theme.breakpoints.down(700)]: {
      width: 550,
    },
    [theme.breakpoints.down(600)]: {
      width: '80%',
    },
    [theme.breakpoints.down(500)]: {
      width: '90%',
    },
  },
  modalTopContainer: {
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    width: '100%',
    borderTopLeftRadius: 15,
    borderTopRightRadius: 15,
    backgroundColor: GlobalStyles.color.COLOR_SECONDARY,
    color: GlobalStyles.color.COLOR_PRIMARY,
    fontFamily: GlobalStyles.fonts.FONT_ANLTP_BOLD,
    fontSize: GlobalStyles.fonts.FONT_SIZE,
    padding: 10,
    position: 'relative',
  },
  modalCloseIconContainer: {
    position: 'absolute',
    cursor: 'pointer',
    right: 10,
    top: 10,
  },
  modalCloseIcon: {
    width: 25,
    height: 25,
  },
  modalContent: {
    display: 'flex',
    padding: 20,
    flexDirection: 'column',
  },
  infoContainer: {
    display: 'flex',
    flexDirection: 'column',
  },
  paragraphLabel: {
    marginTop: 10,
    fontFamily: GlobalStyles.fonts.FONT_ANLTP_BOLD,
    fontSize: GlobalStyles.fonts.FONT_SIZE_SMALL,
    color: GlobalStyles.color.COLOR_BLACK_GREY,
  },
  barcodeImage: {
    position: 'absolute',
    marginTop: 18,
    marginLeft: 20,
    width: 45,
    height: 45,
    zIndex: 5,
    [theme.breakpoints.down(900)]: {
      width: 35,
      height: 35,
      marginLeft: 15,
      marginTop: 26,
    },
    [theme.breakpoints.down(500)]: {
      width: 25,
      height: 25,
      marginLeft: 10,
      marginTop: 13,
    },
  },
  usbScannerText: {
    fontFamily: GlobalStyles.fonts.FONT_ANLTP_REGULAR,
    fontSize: GlobalStyles.fonts.FONT_SIZE_SMALL,
    marginLeft: 7,
  }
});

export default styles;
